<template>
    <div>
        <ComponentHeader />
        <main>
            <HeroComponent title="Contact" img="contact_hero_img.png"  position="35" pageClass="services"/>
            <section class="ContactListSection">
                <div class="ContactListWrapper container">
                    <div class="ContactListBody">
                        <ContactViewComonent :ContactData="dataComponent" />
                    </div>
                </div>
            </section>
            <section class="postUserSection">
                <div class="postUserWrapper container">
                    <div class="postUserBody">
                        <div class="post_user_left">
                            <h3>Get In Touch</h3>
                            <form action="/post" method="post">
                                <input required type="text" placeholder="Name">
                                <input required type="text" placeholder="Last Name">
                                <input required type="email" placeholder="Email">
                                <input required type="number" placeholder="Phone/Telegram">
                                <select required name="" id="">
                                    <option selected value="">
                                        I am interested in

                                    </option>
                                    <option value="">
                                        ITEM 1
                                    </option>
                                    <option value="">
                                        ITEM 2
                                    </option>
                                    <option value="">
                                        ITEM 3
                                    </option>
                                </select>
                                <select required name="" id="">
                                    <option selected value="">
                                        Select Project Budget (in USD)
                                    </option>
                                    <option value="">
                                        ITEM 1
                                    </option>
                                    <option value="">
                                        ITEM 2
                                    </option>
                                    <option value="">
                                        ITEM 3
                                    </option>
                                </select>
                                <textarea required name="" id="" placeholder="About your project" minlength="150"
                                    cols="150" rows="10"></textarea>
                                <button type="Submit">Submit</button>
                            </form>
                        </div>
                        <div class="post_user_right">
                            <h3>Say Hi!</h3>
                            <a href="./">info@pixyz.com</a>
                            <a href="./">+998 71 645 57 67</a>
                            <a href="./">Telegram</a>
                        </div>
                    </div>
                </div>
            </section>
            <section class="mapIframeSection">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2995.770317149119!2d69.29065631528799!3d41.33560757926899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38aef545498aaef5%3A0xc70c624460aad226!2z0LTQstC10YDQuCBlbHBvcnRh!5e0!3m2!1sru!2s!4v1646902508100!5m2!1sru!2s" width="100%" height="760" style="border:0; margin-top: 60px;margin-bottom: 15px;" allowfullscreen="" loading="lazy"></iframe>
            </section>
        </main>
        <FooterCompinent />
    </div>
</template>

<script>
    import ComponentHeader from "@/components/Header.vue";
    import FooterCompinent from "@/components/Footer.vue";
    import ContactViewComonent from "@/components/ContactViewComponent.vue"
    import HeroComponent from "@/components/HeroComonent.vue"
    export default {
        name: "ContactView",
        components: {
            ComponentHeader,
            FooterCompinent,
            ContactViewComonent,
            HeroComponent
        },
        data () {
            return {
                dataComponent: [
                    {
                        img: "location_icon_contact.png",
                        title: "Adress",
                        link: "map:Tashkent, Qazi Mahalla",
                        linkTitle: "Tashkent, Qazi Mahalla"
                    },
                    {
                        img: "tell_icon_contact.png",
                        title: "Phone Number",
                        link: "tel:+998 94 684 38145",
                        linkTitle: "+998 94 684 38145 +998 94 684 38145 +998 94 684 38145"
                    },
                    {
                        img: "message_icon_contact.png",
                        title: "Email",
                        link: "mail:Info@pixyz.uz",
                        linkTitle: "Info@pixyz.uz"
                    }
                ]
            }
        }
    }
</script>


<style lang="scss" scoped>
    .postUserSection {
        margin-top: -70px;
    }
    
    @media only screen and (max-width: 700px) {
        .postUserSection {
            .postUserWrapper {
                .postUserBody {
                    margin: 0 auto;
                    -webkit-box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
                    box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    margin-top: 80px;

                    .post_user_left {
                        width: 100%;
                        padding: 20px;

                        h3 {
                            color: #217a73;
                            font-size: 28px;
                            padding: 10px 0;
                        }

                        form {
                            display: -webkit-box;
                            display: -ms-flexbox;
                            display: flex;
                            -ms-flex-wrap: wrap;
                            justify-content: center;
                            flex-wrap: wrap;
                            width: 100%;

                            input {
                                margin: 10px;
                                padding: 15px;
                                width: 250px!important;
                                border: none;
                                border: 1px solid #49d6cb !important;
                                color: #c9c9c9 !important;
                            }

                            select {
                                padding: 15px;
                                width: 250px;
                                color: #c9c9c9;
                                margin: 10px;
                                border: none;
                                border: 1px solid #49d6cb;
                                background-color: inherit !important;
                            }

                            textarea {
                                width: 520px;
                                margin: 10px;
                                padding: 15px;
                                text-align: left;
                                border: none;
                                color: #c9c9c9;
                                border: 1px solid #49d6cb;
                                background-color: inherit !important;
                                resize: none;
                            }

                            button {
                                background-color: #49d6cb;
                                display: block;
                                border: 1px solid #fff;
                                padding: 15px 50px;
                                color: #fff;
                                margin: 10px;
                                -webkit-transition: all 0.5s;
                                transition: all 0.5s;
                            }

                            button:hover {
                                background-color: #fff;
                                color: #49d6cb;
                                border: 1px solid #49d6cb;
                            }
                        }
                    }

                    .post_user_right {
                        display: none;
                        background-image: url("../assets/images/img_post.png");
                        background-position: bottom right;
                        background-repeat: no-repeat;
                        background-size: 200px;
                        background-color: #49d6cb;
                        width: 420px;
                        padding-left: 30px;

                        h3 {
                            color: #fff;
                            font-size: 32px;
                            font-weight: 600;
                            margin-top: 45px;
                        }

                        a {
                            display: block;
                            color: #fff;
                            font-size: 16px;
                            font-weight: normal;
                            margin-top: 45px;
                        }
                    }

                }
            }
        }
    }

    @media only screen and (max-width: 610px) {
        .postUserSection {
            .postUserWrapper {
                .postUserBody {
                    margin: 0 auto;
                    -webkit-box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
                    box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    margin-top: 80px;

                    .post_user_left {
                        width: 100%;
                        padding: 20px;

                        h3 {
                            color: #217a73;
                            font-size: 28px;
                            padding: 10px 0;
                        }

                        form {
                            display: -webkit-box;
                            display: -ms-flexbox;
                            display: flex;
                            -ms-flex-wrap: wrap;
                            justify-content: center;
                            flex-wrap: wrap;
                            width: 100%;

                            input {
                                margin: 10px;
                                padding: 15px;
                                width: 40%!important;
                                border: none;
                                border: 1px solid #49d6cb !important;
                                color: #c9c9c9 !important;
                            }

                            select {
                                padding: 15px;
                                width: 40%!important;
                                color: #c9c9c9;
                                margin: 10px;
                                border: none;
                                border: 1px solid #49d6cb;
                                background-color: inherit !important;
                            }

                            textarea {
                                width: 84%!important;
                                margin: 10px;
                                padding: 15px;
                                text-align: left;
                                border: none;
                                color: #c9c9c9;
                                border: 1px solid #49d6cb;
                                background-color: inherit !important;
                                resize: none;
                            }

                            button {
                                background-color: #49d6cb;
                                display: block;
                                border: 1px solid #fff;
                                padding: 15px 50px;
                                color: #fff;
                                margin: 10px;
                                -webkit-transition: all 0.5s;
                                transition: all 0.5s;
                            }

                            button:hover {
                                background-color: #fff;
                                color: #49d6cb;
                                border: 1px solid #49d6cb;
                            }
                        }
                    }

                    .post_user_right {
                        display: none;
                        background-image: url("../assets/images/img_post.png");
                        background-position: bottom right;
                        background-repeat: no-repeat;
                        background-size: 200px;
                        background-color: #49d6cb;
                        width: 420px;
                        padding-left: 30px;

                        h3 {
                            color: #fff;
                            font-size: 32px;
                            font-weight: 600;
                            margin-top: 45px;
                        }

                        a {
                            display: block;
                            color: #fff;
                            font-size: 16px;
                            font-weight: normal;
                            margin-top: 45px;
                        }
                    }

                }
            }
        }
    }

    @media only screen and (max-width: 400px) {
        .postUserSection {
            .postUserWrapper {
                .postUserBody {
                    margin: 0 auto;
                    -webkit-box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
                    box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    margin-top: 80px;

                    .post_user_left {
                        width: 100%;
                        padding: 0px;

                        h3 {
                            color: #217a73;
                            font-size: 28px;
                            padding: 10px 0;
                        }

                        form {
                            display: -webkit-box;
                            display: -ms-flexbox;
                            display: flex;
                            -ms-flex-wrap: wrap;
                            justify-content: center;
                            flex-wrap: wrap;
                            width: 100%;
                            margin: 0;
                            input {
                                margin: 10px;
                                padding: 15px;
                                width: 75%!important;
                                border: none;
                                border: 1px solid #49d6cb !important;
                                color: #c9c9c9 !important;
                            }

                            select {
                                padding: 15px;
                                width: 75%!important;
                                color: #c9c9c9;
                                margin: 10px;
                                border: none;
                                border: 1px solid #49d6cb;
                                background-color: inherit !important;
                            }

                            textarea {
                                width: 75%!important;
                                margin: 10px;
                                padding: 15px;
                                text-align: left;
                                border: none;
                                color: #c9c9c9;
                                border: 1px solid #49d6cb;
                                background-color: inherit !important;
                                resize: none;
                            }

                            button {
                                background-color: #49d6cb;
                                display: block;
                                border: 1px solid #fff;
                                padding: 15px 50px;
                                color: #fff;
                                margin: 10px;
                                -webkit-transition: all 0.5s;
                                transition: all 0.5s;
                                width: 80%;
                            }

                            button:hover {
                                background-color: #fff;
                                color: #49d6cb;
                                border: 1px solid #49d6cb;
                            }
                        }
                    }

                    .post_user_right {
                        display: none;
                        background-image: url("../assets/images/img_post.png");
                        background-position: bottom right;
                        background-repeat: no-repeat;
                        background-size: 200px;
                        background-color: #49d6cb;
                        width: 420px;
                        padding-left: 30px;

                        h3 {
                            color: #fff;
                            font-size: 32px;
                            font-weight: 600;
                            margin-top: 45px;
                        }

                        a {
                            display: block;
                            color: #fff;
                            font-size: 16px;
                            font-weight: normal;
                            margin-top: 45px;
                        }
                    }

                }
            }
        }
    }
</style>